<template>
  <div id="home">
    <img src="../assets/images/ba_bg_01.jpg" style="width: 100%;height: 105%;position: fixed;top: 0;" />
    <!-- <van-loading type="spinner" size="34px" color="rgba(243, 187, 98,1)"></van-loading> -->
    <div style="position: relative;z-index: 17;padding-top: 0.78rem;">
      <div class="home_nav">
        <div class="home_nav_img"><img :src="imgtop" /></div>
        <div class="attestation" @click="attestation" v-show="attes">
          <i class="iconfont icon-geren" style="font-size: .5rem;"></i>
          请登录
        </div>
        <div class="attestation" style="width: 1rem;display: flex;justify-content: space-around;" @click="attedele" v-show="attes == false ? true : false">
          <i class="gerenfalse"></i>
        </div>
      </div>
      <div class="home_top">
        <p>历/年/长/沙/教/师/招/聘/考/试</p>
        <i class="home_top_icon"></i>
      </div>
      <div class="home_picker">
        <li class="home_picker_li" style="width: 100%;" @click="particular">
          <i class="iconfont icon-xiala1"></i>
          <span class="iconfont_active" style="">
            <span>年</span>
            <span>份</span>
          </span>
          <input :class="home_year_class" placeholder="填入年份" v-model="home_year_text" readonly="readonly" />
        </li>
        <li class="home_picker_li" style="width: 100%;" @click="subjectclick">
          <i class="iconfont icon-xiala1"></i>
          <span class="iconfont_active" style="">
            <span>地</span>
            <span>市</span>
          </span>
          <input :class="home_subject_class" placeholder="填入地市" v-model="home_subject_text" readonly="readonly" />
        </li>
        <li class="home_picker_li" style="width: 100%;" @click="countyclick">
          <i class="iconfont icon-xiala1"></i>
          <span class="iconfont_active" style="">
            <span>区</span>
            <span>县</span>
          </span>
          <input :class="home_county_class" placeholder="请选择你想查询区县" v-model="home_county_text" readonly="readonly" />
        </li>
        <li class="home_picker_li" style="width: 100%;" @click="levelclick">
          <i class="iconfont icon-xiala1"></i>
          <span class="iconfont_active" style="">
            <span>学</span>
            <span>段</span>
          </span>
          <input :class="home_level_class" placeholder="请选择你想查询学段" v-model="home_level_text" readonly="readonly" />
        </li>
        <li class="home_picker_li" style="width: 100%;" @click="subjectxclick">
          <i class="iconfont icon-xiala1"></i>
          <span class="iconfont_active" style="">
            <span>学</span>
            <span>科</span>
          </span>
          <input :class="home_subjectx_class" placeholder="请选择你想查询学科" v-model="home_subjectx_text" readonly="readonly" />
        </li>
        <li class="home_picker_li" style="width: 100%;" @click="Recruitmentclick">
          <i class="iconfont icon-xiala1"></i>
          <span class="iconfont_active" style="">招聘范围</span>
          <input :class="home_Recruitment_class" placeholder="请选择你想查询招聘范围" v-model="home_Recruitment_text" readonly="readonly" />
        </li>
        <li class="home_picker_li" style="width: 100%;" @click="sexclick">
          <i class="iconfont icon-xiala1"></i>
          <span class="iconfont_active" style="">
            <span>性</span>
            <span>别</span>
          </span>
          <input :class="home_sex_class" placeholder="请选择你想查询性别" v-model="home_sex_text" readonly="readonly" />
        </li>
        <div class="home_btn"><button class="inquire" @click="inquire">点击查询</button></div>
      </div>
    </div>

    <!-- 登录 -->
    <div class="login" v-show="loginShow">
      <div class="login_content">
        <div class="login_content_top">
          <div><img class="close" src="../assets/images/close.png" alt="" @click="close" /></div>
          <span class="auth" v-show="approveShow">短信验证码登录</span>
          <span class="auth" v-show="absenceShow">账号密码登录</span>
        </div>
        <!-- 未认证 -->
        <div v-show="approveShow">
          <div style="position: relative;">
            <i class="auth_home"></i>
            <input class="mobile" type="text" placeholder="请输入姓名" maxlength="11" v-model="verify_mobile_name" />
          </div>
          <div style="position: relative;">
            <i class="auth_two"></i>
            <input class="mobile" type="text" placeholder="请输入手机号" maxlength="11" v-model="verify_mobile_phone" />
          </div>

          <div class="auth_code" style="position: relative;height: .72rem;">
            <i class="auth_yes"></i>
            <input class="mobiletop" type="text" placeholder="验证码" style="padding-left: .82rem;" maxlength="6" v-model="captcha" />
            <span v-show="zheng" @click="acquire">获取验证码</span>
            <span v-show="!zheng" class="count">{{ count }} s后重新获取</span>
          </div>
          <p class="login_p">
            注册的手机号验证后将自动为您创建新百易网校账号，登录即代表您已同意《
            <span>新百易网校用户服务协议</span>
            》
          </p>
          <button class="login_btn" @click="login(1)">登录</button>
          <span @click="unverified" class="login_tab">账号密码登录</span>
        </div>
        <!-- 已认证 -->
        <div v-show="absenceShow">
          <div style="position: relative;">
            <i class="auth_two"></i>
            <input class="mobile" type="text" placeholder="请输入账号/手机号码" maxlength="" v-model="verify_mobile_phones" />
          </div>
          <div style="position: relative;">
            <i class="auth_gjgj"></i>
            <input class="mobile" type="password" placeholder="请输入密码" maxlength="20" v-model="verify_mobile_password" />
          </div>
          <button class="login_btn" @click="login(2)">登录</button>
          <span @click="authenticated" class="login_tab">短信验证码登录</span>
        </div>
      </div>
    </div>
    <van-picker show-toolbar title="年份" :columns="home_year" value-key="name" @cancel="onCancel" @confirm="particularSelect" v-show="home_year_show" />

    <!-- 查询结果 -->
    <div class="home_daio home_daiotop" style="display: none;position:absolute;left: 0; right: 0;margin: auto;">
      <div class="home_daio_top">
        <div class="imgtt_bolck" style="position: relative;z-index: 77;">
          <i class="itop" @click="home_click"></i>
          <img
            style="margin: 0 auto;display: block;"
            src=""
            class="imgtt"
            alt="新百易-入面查询分数"
            name="新百易-入面查询分数"
            title="新百易-入面查询分数"
            id="新百易-入面查询分数"
            crossorigin="anonymous"
          />
        </div>

        <div class="home_daio_images" style="position:  relative;z-index: 77;">长按保存图片，分享给微信好友或微信群</div>
        <div class="home_daioxxx" style="display: none;">
          <div class="home_daio_bot">
            <img src="../assets/images/logo_02.png" />
            <p>历年长沙教师招聘考试岗位竞争比查询结果教师招聘考试 入面分数线查询结果</p>
          </div>
          <div class="home_daio_bottom">
            <div class="home_daio_tab">
              <div class="home_daio_th">
                <div class="home_daio_tr">查询岗位</div>
                <div class="home_daio_tr">入面最低分</div>
                <div class="home_daio_tr">入面最高分</div>
              </div>

              <div class="home_daio_th home_daio_thtt">
                <div class="home_daio_td">1</div>
                <div class="home_daio_td">2</div>
                <div class="home_daio_td">3</div>
              </div>
            </div>
            <div class="home_daio_measurement">
              <h4>—— 测一测 你的岗位竞争比是多少？——</h4>
              <div class="home_daio_measurement_code">
                <div class="home_daio_left">
                  <div>
                    <p>长按识别二维码</p>
                    <i></i>
                  </div>
                  <div>
                    <div>一键查询</div>
                    <span>你心仪岗位的竞争比~</span>
                  </div>
                </div>
                <div class="home_daio_right"><img src="../assets/images/ba_bg_05.png" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 黑幕 -->
    <div class="inside" style="display: none;"></div>

    <!-- 暂无查询结果 -->
    <div class="home_daio home_daioit" style="display: none;">
      <div class="home_daio_top" style="z-index: 100;position: absolute;left: 0;right: 0;margin: 0;">
        <div class="home_daio_bot">
          <i @click="home_click"></i>
          <img src="../assets/images/logo_02.png" />
          <p>{{ home_year_text }}{{ home_subject_text }}{{ home_county_text }}教师招聘考试岗位竞争比查询结果</p>
        </div>
        <div class="home_daio_bottom">
          <div class="home_daio_tab">
            <div class="home_daio_th">
              <div class="home_daio_tr" :style="{ width: vsshow == true ? '29%' : '40%' }">岗位名称</div>
              <div class="home_daio_tr">招聘数</div>
              <div class="home_daio_tr" v-if="vsshow">调整招聘数</div>
              <div class="home_daio_tr">报名人数</div>
              <div class="home_daio_tr">竞争比</div>
            </div>
            <div class="home_daio_th">
              <div class="home_daio_td toboc">{{ message }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="home_daiox" style="position: fixed;top: 0;z-index: 99;display: none;z-index: -1;">
      <div class="home_daio_bot">
        <img src="../assets/images/logo_02.png" />
        <p>{{ home_year_text }}{{ home_subject_text }}{{ home_county_text }}教师招聘考试岗位竞争比查询结果</p>
      </div>
      <div class="home_daio_bottom">
        <div class="home_daio_tab">
          <div class="home_daio_th">
            <div class="home_daio_tr" :style="{ width: vsshow == true ? '28%' : '40%' }">岗位名称</div>
            <div class="home_daio_tr">招聘数</div>
            <div class="home_daio_tr" v-if="vsshow">调整后招聘数</div>
            <div class="home_daio_tr">报名人数</div>
            <div class="home_daio_tr">竞争比</div>
          </div>

          <div class="home_daio_th home_daio_thtt" v-for="(item, index) in listbox" :key="index">
            <div class="home_daio_td" :style="{ width: vsshow == true ? '28%' : '40%' }">{{ item.job_name }}</div>
            <div class="home_daio_td">{{ item.recruit_num }}</div>
            <div class="home_daio_td" v-if="vsshow">{{ item.recruit_modify_num }}</div>
            <div class="home_daio_td">{{ item.sign_num }}</div>
            <div class="home_daio_td">{{ item.ratio }}</div>
          </div>
        </div>
        <div class="home_daio_measurement">
          <h4>—— 测一测 你的岗位竞争比是多少？——</h4>
          <div class="home_daio_measurement_code">
            <div class="home_daio_left">
              <div>
                <p>长按识别二维码</p>
                <i></i>
              </div>
              <div>
                <div>一键查询</div>
                <span>你心仪岗位的竞争比~</span>
              </div>
            </div>
            <div class="home_daio_right"><img src="../assets/images/code.png" /></div>
          </div>
        </div>
      </div>
    </div>

    <van-picker show-toolbar title="地市" :columns="home_subject" value-key="name" @cancel="onCancel" @confirm="subjectSelect" v-show="home_subject_show" />
    <van-picker show-toolbar title="区县" :columns="home_county" value-key="name" @cancel="onCancel" @confirm="countySelect" v-show="home_county_show" />
    <van-picker show-toolbar title="学段" :columns="home_level" value-key="name" @cancel="onCancel" @confirm="levelSelect" v-show="home_level_show" />
    <van-picker show-toolbar title="学科" :columns="home_subjectx" value-key="name" @cancel="onCancel" @confirm="subjectxSelect" v-show="home_subjectx_show" />
    <van-picker show-toolbar title="招聘范围" :columns="home_Recruitment" value-key="name" @cancel="onCancel" @confirm="RecruitmentSelect" v-show="home_Recruitment_show" />
    <van-picker show-toolbar title="性别" :columns="home_sex" value-key="name" @cancel="onCancel" @confirm="sexSelect" v-show="home_sex_show" />
  </div>
</template>
<script>
import qs from 'qs';
import { Dialog } from 'vant'; //提示框
export default {
  data() {
    return {
      imgtop: '../assets/images/logo_02.png', //logo
      attes: true, //登录状态
      loginShow: false, //登录
      absenceShow: false, //登录状态
      count: '', //验证码
      approveShow: true,
      captcha: null,
      vsshow: false,
      absenceShow: false,
      zheng: true, //验证码状态
      timer: null, //验证码时间
      verify_mobile_name: '', //姓名
      verify_mobile_password: '', //密码
      verify_mobile_phone: '', //手机号
      verify_mobile_phones: '',
      url: 'https://apinew.5kjs.com/activity.', //请求地址 http://api.xueba.hk/activity. https://apinew.5kjs.com/activity.
      urlogo:'https://apinew.5kjs.com/activity.',
      //年份
      home_year_class: 'tobl',
      home_year_text: '',
      home_year_show: '',
      home_year: [],
      home_yearList: [],
      //地市
      home_subject_class: 'tobl',
      home_subject_text: '',
      home_subject_show: '',
      home_subject: [],
      home_subjectList: [],
      //区县
      home_county_class: 'tobl',
      home_county_text: '',
      home_county_show: '',
      home_county: [],
      home_countyList: [],
      //学段
      home_level_class: 'tobl',
      home_level_text: '',
      home_level_show: '',
      home_level: [],
      home_levelList: [],
      //学科
      home_subjectx_class: 'tobl',
      home_subjectx_text: '',
      home_subjectx_show: '',
      home_subjectx: [],
      home_subjectxList: [],
      //招聘范围
      home_Recruitment_class: 'tobl',
      home_Recruitment_text: '',
      home_Recruitment_show: '',
      home_Recruitment: [],
      home_RecruitmentList: [],
      //性别
      home_sex_class: 'tobl',
      home_sex_text: '',
      home_sex_show: '',
      home_sex: [],
      home_sexList: [],
      imgtop: '',
      imgid: '',
      itm: 1,
      message: '',
      listbox: []
    };
  },

  created() {
    var than = this;
    var that = this
    $.get(window.location.origin + '/m/session/login', { }, function(res) {
   function getUrlParam(name) {
   		  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); //构造一个含有目标参数的正则表达式对象
   		  var r = window.location.search.substr(1).match(reg); //匹配目标参数
   		  if (r != null) return unescape(r[2]);
   		  return null; //返回参数值
   		}

    // 自动判断当前环境
    var thisUrl = window.location.origin

    if (thisUrl.search(/test2.5kjs/g) != -1) {
      than.url = "http://apinew2.5kjs.com/activity."
    } else if (thisUrl.search(/xueba.com/g) != -1) {
      than.url = "http://apinew.xueba.hk/activity."
    } else if (thisUrl.search(/xueba.hk/g) != -1) {
      than.url = "http://apinew.xueba.hk/activity."
    } else if (thisUrl.search(/localhost:/g) != -1) {
      than.url = "http://apinew.xueba.hk/activity."
    } else {
      than.url = "https://apinew.5kjs.com/activity."
    }
   		var sign = getUrlParam('sign');
   		if(than.getCookie("api_token") == null || than.getCookie("api_token") == "") {
   		  than.attes = true;
   		  localStorage.removeItem('api_token')
   		  localStorage.setItem('sign', sign);
   		  localStorage.removeItem('token')
   		}else {
   		  sign = than.getCookie("api_token")
   		  localStorage.setItem("api_token",than.getCookie("api_token"))
   		  than.attes = false;
   		}
    // const host = window.location.host; //localhost
    const host = 'hnjszp.5kjs.com'; //localhost
    var localhost = window.location.href; //localhost

    var domainx = localStorage.getItem('domain');
    // var domainx = 'https://hnjszp.5kjs.com/';

    if (domainx == null) {
      //host 获取agency_id host https://hnjszp.5kjs.com/
      $.get(than.url + 'compete_ratio/getAgencyInfo', { domain: host }, function(res) {
        if (res.code == 200) {
          localStorage.setItem('domain', JSON.stringify(res.data));
          domainx = localStorage.getItem('domain');
          than.imgtop = JSON.parse(domainx).path;
          than.imgid = JSON.parse(domainx).agency_id;
          if (sign != null) {
            if (localhost.indexOf('?') != -1) {
              localhost = localhost.split('?')[0];
            }
            const local = localStorage.getItem('localhost');
            localStorage.setItem('sign',sign)
            if (local == null) {
              localStorage.setItem('localhost', localhost);
            }
            //apinew2.5kjs.com/activity.query_score/loginJump than.$url +
            $.get( than.url + 'query_score/loginJump', { agency_id: JSON.parse(domainx).agency_id, sign: sign, syn_type: 'compete_ratio' , from_mobile:0 }, function(result) {
              // than.$toast(result.message);
              if (result.code == 200) {
                localStorage.setItem('token', result.data.token);
                localStorage.setItem('userId ', result.data.userId );
                localStorage.setItem('agencyId ', result.data.agencyId );
                than.token = localStorage.getItem('token');
                than.loginShow = false;
                than.attes = false;
              }
            });
          } else {
            localStorage.setItem('localhost', localhost);
          }
          $.get(than.url + 'compete_ratio/getConfigList', { agency_id: JSON.parse(domainx).agency_id }, function(res) {
            if (res.code == 200) {
              than.home_year_text = res.data.year[res.data.year.length - 1]; //年份
              than.home_yearList = res.data.year; //年份

              than.home_subject_text = res.data.city[0].name; //地市
              than.home_subjectList = res.data.city; //地市

              than.home_sex_text = res.data.gender[0].name; //性别
              than.home_sexList = res.data.gender; //性别

              than.home_levelList = res.data.levelList; //学段

              than.home_subjectxList = res.data.subjectList; //学科

              than.home_Recruitment_text = res.data.recruit_range[0].name; //招聘范围
              than.home_RecruitmentList = res.data.recruit_range; //招聘范围

              than.home_yearList.forEach(function(datas, index) {
                //年份
                var box = datas;
                than.home_year.push(box);
              });

              than.home_subjectList.forEach(function(datas, index) {
                //地市
                var box = datas.name;
                than.home_subject.push(box);
              });

              than.home_sexList.forEach(function(datas, index) {
                //性别
                var box = datas.name;
                than.home_sex.push(box);
              });

              than.home_levelList.forEach(function(datas, index) {
                //学段
                var box = datas.name;
                than.home_level.push(box);
              });

              than.home_subjectxList.forEach(function(datas, index) {
                //学科
                var box = datas.name;
                than.home_subjectx.push(box);
              });

              than.home_RecruitmentList.forEach(function(datas, index) {
                //招聘范围
                var box = datas.name;
                than.home_Recruitment.push(box);
              });

              than.home_subjectList.forEach(function(datas, index) {
                if (datas.name == than.home_subject_text) {
                  $.get(
                    than.url + 'compete_ratio/getDistrict',
                    {
                      city: than.home_subjectList[0].id,
                      year: than.home_year_text
                    },
                    function(res) {
                      if (res.code == 200) {
                        than.home_countyList = res.data;
                        res.data.forEach(function(datas, index) {
                          //招聘范围
                          var box = datas.name;
                          than.home_county.push(box);
                        });
                      }
                    }
                  );
                }
              });
            }
          });
        }
      });
    }
    if (sign != null && domainx != null) {
      console.log(localhost);
      if (localhost.indexOf('?') != -1) {
        localhost = localhost.split('?')[0];
      }
      const local = localStorage.getItem('localhost');
      localStorage.setItem('sign',sign)
      if (local == null) {
        localStorage.setItem('localhost', localhost);
      }
      //apinew2.5kjs.com/activity.query_score/loginJump than.$url +
      $.get( than.url + 'query_score/loginJump', { agency_id: JSON.parse(domainx).agency_id, sign: sign, syn_type: 'compete_ratio' , from_mobile:0 }, function(result) {
        // than.$toast(result.message);
        if (result.code == 200) {
          localStorage.setItem('token', result.data.token);
          localStorage.setItem('userId ', result.data.userId );
          localStorage.setItem('agencyId ', result.data.agencyId );
          than.token = localStorage.getItem('token');
          than.loginShow = false;
          than.attes = false;
        }
      });
    } else {
      localStorage.setItem('localhost', localhost);
    }

    than.token = localStorage.getItem('token'); //是否登录
    if (than.token === null) {
      than.attes = true;
    } else {
      than.attes = false;
    }

    if (domainx !== null) {
      than.imgtop = JSON.parse(domainx).path;
      than.imgid = JSON.parse(domainx).agency_id;
      than.home_year = [];
      than.home_subject = [];
      than.home_sex = [];
      than.home_level = [];
      than.home_subjectx = [];
      than.home_Recruitment = [];
      than.home_county = [];
      $.get(than.url + 'compete_ratio/getConfigList', { agency_id: JSON.parse(domainx).agency_id }, function(res) {
        if (res.code == 200) {
          than.home_year_text = res.data.year[res.data.year.length - 1]; //年份
          than.home_yearList = res.data.year; //年份

          than.home_subject_text = res.data.city[0].name; //地市
          than.home_subjectList = res.data.city; //地市

          than.home_sex_text = res.data.gender[0].name; //性别
          than.home_sexList = res.data.gender; //性别

          than.home_levelList = res.data.levelList; //学段

          than.home_subjectxList = res.data.subjectList; //学科

          than.home_Recruitment_text = res.data.recruit_range[0].name; //招聘范围
          than.home_RecruitmentList = res.data.recruit_range; //招聘范围

          than.home_yearList.forEach(function(datas, index) {
            //年份
            var box = datas;
            than.home_year.push(box);
          });

          than.home_subjectList.forEach(function(datas, index) {
            //地市
            var box = datas.name;
            than.home_subject.push(box);
          });

          than.home_sexList.forEach(function(datas, index) {
            //性别
            var box = datas.name;
            than.home_sex.push(box);
          });

          than.home_levelList.forEach(function(datas, index) {
            //学段
            var box = datas.name;
            than.home_level.push(box);
          });

          than.home_subjectxList.forEach(function(datas, index) {
            //学科
            var box = datas.name;
            than.home_subjectx.push(box);
          });

          than.home_RecruitmentList.forEach(function(datas, index) {
            //招聘范围
            var box = datas.name;
            than.home_Recruitment.push(box);
          });

          than.home_subjectList.forEach(function(datas, index) {
            if (datas.name == than.home_subject_text) {
              $.get(
                than.url + 'compete_ratio/getDistrict',
                {
                  city: than.home_subjectList[0].id,
                  year: than.home_year_text
                },
                function(res) {
                  if (res.code == 200) {
                    than.home_countyList = res.data;
                    res.data.forEach(function(datas, index) {
                      //招聘范围
                      var box = datas.name;
                      than.home_county.push(box);
                    });
                  }
                }
              );
            }
          });
        }
      });
    }
    var listdatas = JSON.parse(sessionStorage.getItem('listdata'));

    if(listdatas != null){
      setTimeout(function(){
        that.home_year_text = listdatas.home_year_text
        that.home_subject_text = listdatas.home_subject_text
        that.home_Recruitment_text = listdatas.home_Recruitment_text
        that.home_sex_text = listdatas.home_sex_text
      },400)


    	if(listdatas.home_county_text != '请选择你想查询的区县') {
    		than.home_county_text =listdatas.home_county_text
    		than.home_county_class = 'tobl'
    	}else{
    		than.home_county_class = 'modebox'
    	}
    	if(listdatas.home_level_text != '请选择你想查询的学段') {
    		than.home_level_text = listdatas.home_level_text
    		than.home_level_class = 'tobl'
    	}else {
    		than.home_level_class = 'modebox'
    	}
    	if(listdatas.home_subjectx_text != '请选择你想查询的学科') {
    		than.home_subjectx_text =  listdatas.home_subjectx_text
    		than.home_subject_class = 'tobl'
    	}else {
    		than.home_subject_class = 'modebox'
    	}
    }
  })
  },
  updated() {},
  methods: {
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i].trim();
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
    },
    // 点击关闭弹窗
    close() {
      this.loginShow = false;
    },
    // 获取验证码
    acquire() {
      if (this.verMobile()) {
        const TIME_COUNT = 60;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.zheng = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.zheng = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
        this.mobilePhone();
      }
    },
    // 校验验证码接口
    mobilePhone() {
      var than = this;
      var domainx = localStorage.getItem('domain');
      $.get(this.url + 'query_score/smsSend', { agency_id: JSON.parse(domainx).agency_id, mobile: this.verify_mobile_phone }, function(res) {
        if (res.code == 200) {
          than.$toast(res.message);
        }
      });
    },
    //点击图标隐藏
    home_click() {
      $('.home_daio').hide();
      $('.inside').hide();
      $('.home_daiox').hide();
      $('.imgtt').css('height', '0');
      $('.imgtt_bolck').css('height', '0');
      $('.home_daio_images').hide();
    },
    // 验证手机正则
    verMobile() {
      var than = this;
      if (this.verify_mobile_phone === '') {
        than.$toast('请输入要登录的手机号');
        return false;
      } else {
        var reg = /^1[3456789]\d{9}$/;
        if (!reg.test(this.verify_mobile_phone)) {
          than.$toast('请输入有效的手机号码');
          return false;
        }
      }

      return true;
    },
    //点击登录
    attestation() {
      Dialog.confirm({
        title: '还没有登录哦~ 是否登录跳转',
        message: ''
      })
        .then(() => {
          // this.loginShow = true
          var listdata = {
          	home_year_text:this.home_year_text,
          	home_subject_text:this.home_subject_text,
          	home_subjectx_text:this.home_subjectx_text,
          	home_county_text:this.home_county_text,
          	home_level_text:this.home_level_text,
          	home_Recruitment_text:this.home_Recruitment_text,
          	home_sex_text:this.home_sex_text,
          }

          var listdata = sessionStorage.setItem('listdata',JSON.stringify(listdata));
          var localhost = localStorage.getItem('localhost');
          var host = window.location.origin
          window.location.href = window.location.origin  + '/m/login?source=compete_ratio'+ '&turn_jump_url='  + localhost ;

        })
        .catch(() => {});
    },
    // 登录验证接口
    verifyPhone(i, than) {
      var preams = [];
      var than = this;
      var domainx = localStorage.getItem('domain');
      if (i == 1) {
        preams = {
          login_type: i,
          agency_id: JSON.parse(domainx).agency_id,
          syn_type: 'compete_ratio',
          name: this.verify_mobile_name,
          mobile: this.verify_mobile_phone,
          code: this.captcha
        };
      } else {
        preams = {
          login_type: i,
          agency_id: JSON.parse(domainx).agency_id,
          syn_type: 'compete_ratio',
          username: this.verify_mobile_phones,
          password: this.verify_mobile_password
        };
      }
      $.get(than.url + 'query_score/login', preams, function(res) {
        than.$toast(res.message);
        if (res.code == 200) {
          than.attes = false;
          than.loginShow = false;
          localStorage.setItem('uuid', res.data.uuid);
          localStorage.setItem('token', res.data.token);
        }
      });
    },
    // 登录校验
    login(i) {
      var than = this;
      this.itm = i;
      if (i == 1) {
        if (this.approveShow === true) {
          if (this.verMobile()) {
            if (this.verify_mobile_name === '') {
              than.$toast('名字不可以为空!');
            } else if (this.captcha === null) {
              than.$toast('验证码不能为空!');
            } else {
              if (this.captcha.length !== 6) {
                than.$toast('请输入6位验证码!');
              } else {
                this.verifyPhone(i, this);
              }
            }
          }
        } else {
          if (this.verMobile()) {
            this.certifiedMobile();
          } else {
            this.verMobile();
          }
        }
      } else {
        if (this.verify_mobile_phones === '') {
          than.$toast('名字不可以为空!');
        } else if (this.verify_mobile_password === '') {
          than.$toast('密码不能为空!');
        } else {
          this.verifyPhone(i);
        }
      }
    },
    // 已认证身份事件1
    authenticated() {
      this.auth = 'blue';
      this.vnve = '';
      this.approveShow = true;
      this.absenceShow = false;
    },
    // 未认证事件
    unverified() {
      this.auth = '';
      this.vnve = 'blue';
      this.approveShow = false;
      this.absenceShow = true;
    },
    //退出登录
    attedele() {
      var than = this;
      var token = localStorage.getItem('token');
      var host = window.location.host; //localhost
      Dialog.confirm({
        title: '是否确认退出',
        message: ''
      })
        .then(() => {
          $.get(window.location.origin + '/m/linklogout', {token:token,link:window.location.host,url:window.location.origin + '/activity/questions/#/' }, function(res) {
            // than.$toast(res.msg);
            if( res.code == 1 ) {
              var localhost = localStorage.getItem('localhost');
              window.location.href = localhost;
              localStorage.removeItem('token');
              localStorage.removeItem('uuid');
              than.loginShow = false;
              than.attes = true;
              var listdata = {
              	home_year_text:than.home_year_text,
              	home_subject_text:than.home_subject_text,
              	home_subjectx_text:'请选择你想查询的学科',
              	home_county_text:'请选择你想查询的区县',
              	home_level_text:'请选择你想查询的学段',
              	home_Recruitment_text:than.home_Recruitment_text,
              	home_sex_text:than.home_sex_text,
              }
              var listdata = sessionStorage.setItem('listdata',JSON.stringify(listdata));
              than.verify_mobile_password = '';
              than.verify_mobile_passwords = '';
              than.verify_mobile_phone = '';
              than.verify_mobile_name = '';
              window.location.href =  window.location.origin +  window.location.pathname;
            }
          });
         })
        .catch(() => {});
    },

    //点击查询
    inquire() {
      var list = ['1'];
      if (this.attes != true) {
        var than = this;
        var domainx = localStorage.getItem('domain');
        if (domainx == null) {
          window.location.reload();
        }
        var params = {
          token: localStorage.getItem('token'),
          year: this.home_year_text, //年份
          // city:this.home_subject_text,//长沙
          district: this.home_county_text, //区县
          level: this.home_level_text, //学段
          // other:0,
          subject: this.home_subjectx_text, //学科
          recruit_range: this.home_Recruitment_text, //招聘范围
          gender: this.home_sex_text, //性别
          agency_id: JSON.parse(domainx).agency_id //机构id
        };

        than.home_subjectList.forEach(function(datas, index) {
          if (datas.name == than.home_subject_text) {
            params.city = datas.id; //地市id
          }
        });

        than.home_countyList.forEach(function(datas, index) {
          if (datas.name == than.home_county_text) {
            params.district = datas.id; //区县id
          }
        });

        than.home_levelList.forEach(function(datas, index) {
          if (datas.name == than.home_level_text) {
            params.level = datas.id; //学段id
          }
        });

        than.home_subjectxList.forEach(function(datas, index) {
          if (datas.name == than.home_subjectx_text) {
            params.subject = datas.id; //学段id
          }
        });

        than.home_RecruitmentList.forEach(function(datas, index) {
          if (datas.name == than.home_Recruitment_text) {
            params.recruit_range = datas.id; //招聘范围id
          }
        });

        than.home_sexList.forEach(function(datas, index) {
          if (datas.name == than.home_sex_text) {
            params.gender = datas.id; //招聘范围id
          }
        });
        if (this.home_county_text == '') {
          this.$toast('区县不可以为空!');
        } else if (this.home_level_text == '') {
          this.$toast('学段不可以为空!');
        } else if (this.home_subjectx_text == '') {
          this.$toast('学科不可以为空!');
        } else if (this.home_Recruitment_text == '') {
          this.$toast('招聘范围不可以为空!');
        } else if (this.home_sex_text == '') {
          this.$toast('性别不可以为空!');
        } else {
          $.get(than.url + 'compete_ratio/getCompeteRatioList', params, function(res) {
            if (res.code == 200) {
              if (res.data.is_show == 1) {
                than.vsshow = true;
              }
              if (res.data.list != '') {
                than.listbox = res.data.list;
                $('.home_daiotop').show();
                $('.home_daioxxx').show();
                $('.inside').show();
                $('.home_daiox').show();

                var height = 0;
                setTimeout(() => {
                  height = $('.home_daiox').outerHeight();
                  $('.home_daiotop').css('top', ($('html').outerHeight() - $('.home_daiotop > .home_daio_top').outerHeight()) / 2);
                  $('.home_daioxxx').css('top', ($('html').outerHeight() - $('.home_daiotop > .home_daio_top').outerHeight()) / 2);
                  $('.home_daioxxx').hide();
                }, 10);
                setTimeout(() => {
                  html2canvas(document.querySelector('.home_daiox'), { x: $('body').left, y: $('body').top, useCORS: true, dpi: window.devicePixelRatio * 2 }).then(canvas => {
                    $('.home_daiox').hide();
                    $('.imgtt').attr('src', canvas.toDataURL());
                    $('.imgtt').css('height', height);
                    $('.imgtt_bolck').css('height', height);
                    if (($('html').outerHeight() - $('.imgtt').outerHeight()) / 2 < 30) {
                      $('.home_daiotop').css('top', '15px');
                    }
                    setTimeout(() => {
                      $('.imgtt').show();
                      $('.home_daio_images').show();
                    }, 500);
                  });
                }, 10);
              } else {
                // than.$toast( res.message);
                than.message = res.message;
                $('.home_daioit').show();
                $('.home_daiotop').hide();
                $('.inside').show();
                $('.home_daioit > .home_daio_top').css('top', ($('body').height() - $('.home_daioit > .home_daio_top').height()) / 2 + 'px');
              }
            } else if (res.code == 202) {
              than.$toast('未登录 点击右上角进行登录');
              localStorage.removeItem('token');
              localStorage.removeItem('uuid');
              than.loginShow = false;
              than.attes = true;
              // than.loginShow = true;
            } else {
              than.$toast(res.message);
            }
          });
        }
      } else {
        // this.$toast('未登录 点击右上角登录 !');
        this.attestation()
      }
    },
    //点击年份
    particular() {
      this.home_year_show = true;
    },
    // 年份选择器点击确定事件
    particularSelect(value, index) {
      this.home_year_text = value;
      this.home_year_class = 'tobl';
      var than = this;
      this.home_year_show = false;
      $.get(
        than.url + 'compete_ratio/getDistrict',
        {
          city: than.home_subjectList[0].id,
          year: than.home_year_text
        },
        function(res) {
          if (res.code == 200) {
            than.home_county = []
            than.home_countyList = []
            than.home_countyList = res.data;
            than.home_county_text = ''
            res.data.forEach(function(datas, index) {
              //招聘范围
              var box = datas.name;
              than.home_county.push(box);
            });
          }
        }
      );
    },
    //点击地市
    subjectclick() {
      this.home_subject_show = true;
    },
    //点击地市选择器点击确定事件
    subjectSelect(value, index) {
      this.home_subject_text = value;
      var than = this;
      than.home_county = [];
      $.get(
        than.url + 'compete_ratio/getDistrict',
        {
          city: than.home_subjectList[index].id,
          year: than.home_year_text
        },
        function(res) {
          if (res.code == 200) {
            than.home_county = []
            than.home_countyList = []
            than.home_countyList = res.data;
            res.data.forEach(function(datas, index) {
              //招聘范围
              var box = datas.name;
              than.home_county.push(box);
            });
          }
        }
      );
      this.home_subject_class = 'tobl';
      var than = this;
      this.home_subject_show = false;
    },
    //点击区县
    countyclick() {
      this.home_county_show = true;
    },
    //点击区县选择器点击确定事件
    countySelect(value, index) {
      this.home_county_text = value;
      this.home_countyclass = 'tobl';
      var than = this;
      this.home_county_show = false;
    },
    //点击学段
    levelclick() {
      this.home_level_show = true;
    },
    //点击学段选择器点击确定事件
    levelSelect(value, index) {
      this.home_level_text = value;
      this.home_levelclass = 'tobl';
      var than = this;
      this.home_level_show = false;
    },
    //点击学科
    subjectxclick() {
      this.home_subjectx_show = true;
    },
    //点击学科选择器点击确定事件
    subjectxSelect(value, index) {
      this.home_subjectx_text = value;
      this.home_subjectxclass = 'tobl';
      var than = this;
      this.home_subjectx_show = false;
    },
    //点击招聘范围
    Recruitmentclick() {
      this.home_Recruitment_show = true;
    },
    //点击招聘范围选择器点击确定事件
    //点击招聘范围选择器点击确定事件
    RecruitmentSelect(value, index) {
      this.home_Recruitment_text = value;
      this.home_Recruitmentclass = 'tobl';
      var than = this;
      this.home_Recruitment_show = false;
    },
    //点击性别
    sexclick() {
      this.home_sex_show = true;
    },
    //点击招聘范围选择器点击确定事件
    //点击性别选择器点击确定事件
    sexSelect(value, index) {
      this.home_sex_text = value;
      this.home_sexclass = 'tobl';
      var than = this;
      this.home_sex_show = false;
    },

    // 选择器点击取消事件
    //选择器全部取消
    onCancel() {
      this.home_year_show = false;
      this.home_subject_show = false;
      this.home_county_show = false;
      this.home_level_show = false;
      this.home_subjectx_show = false;
      this.home_Recruitment_show = false;
      this.home_sex_show = false;
    }
  }
};

$(function() {
  // $('.home_top > p').arctext({radius: 500});
  $('.inside').on('click', function() {
    $(this).hide();
    $('.imgtt').attr('src', '');
    $('.imgtt').css('height', '0');
    $('.imgtt_bolck').css('height', '0');
    $('.home_daio').hide();
    $('.home_daio_images').hide();
  });
});
</script>
<style scoped>
@import '../assets/font/iconfont.css';
#home {
  width: 100%;
  height: 15.2rem;
  /* background: url(../assets/images/ba_bg_01.jpg) center center no-repeat; */
  background-size: 100% 100%;
}

.home_daiox {
  z-index: -1;
}

.home_daio_bottom {
  width: 7.05rem;
  overflow: hidden;
  margin: 0 auto;
  background-color: #fff;
  padding: 0.25rem 0;
  border-radius: 0 0 0.21rem 0.21rem;
}

.home_daio_tab {
  width: 6.45rem;
  border: 0.01rem solid #a7a7a7;
  border-radius: 0.1rem;
  margin: 0 auto;
}

.home_daio_tab > .home_daio_th {
  border-bottom: 0.01rem solid #a7a7a7;
  display: flex;
}

.home_daio_tab > .home_daio_th > .home_daio_tr {
  width: 20%;
  padding: 0.12rem 0;
  /* line-height: .8rem; */
  text-align: center;
  border-right: 0.01rem solid #a7a7a7;
  font-size: 0.21rem;
  font-weight: 400;
  color: #1e1e2a;
}
.home_daio_tab > .home_daio_th > .home_daio_tr:nth-child(5n) {
  border-right: none;
}

.home_daio_tab > .home_daio_th:last-child {
  border-bottom: none;
}

.home_daio_tab > .home_daio_th > .home_daio_td {
  /* line-height: .4rem; */
  width: 20%;
  text-align: center;
  padding: 0.12rem 0;
  border-right: 0.01rem solid #a7a7a7;
  font-size: 0.21rem;
  font-weight: 400;
  color: #1e1e2a;
}

.home_daio_tab > .home_daio_th > .home_daio_td:last-child {
  border-right: none;
}
.home_daio_tab > .home_daio_th > .home_daio_td:nth-child(1) {
  /* line-height: .4rem; */
  width: 30%;
  text-align: center;
}

.home_daio_tab > .home_daio_th > .toboc {
  padding: 0.12rem 0;
  width: 100% !important;
  text-align: center;
}

.home_daio_tab > .home_daio_th > .home_daio_tr:nth-child(1) {
  width: 30%;
}
.home_daio_tab > .home_daio_th > .home_daio_tr:nth-child(5n) {
  border-right: none;
}

.home_daio_measurement > .home_daio_measurement_code {
  width: 6.45rem;
  /* height: 1.64rem; */
  background: #e6e6e6;
  margin: 0 auto;
  border-radius: 0.21rem;
  margin-top: 0.2rem;
  display: flex;
  justify-content: space-between;
}

.home_daio_left > div:nth-child(1) {
  border-bottom: 0.01rem solid #a7a7a7;
  display: flex;
}

.home_daio_left > div:nth-child(1) > p {
  font-size: 0.29rem;
  font-weight: bold;
  color: #1e1e2a;
  line-height: 0.63rem;
  text-align: left;
}

.home_daio_right {
  width: 1.5rem;
  height: 1.5rem;
  margin-right: 0.2rem;
  margin-top: 0.3rem;
}

.home_daio_left {
  padding: 0.36rem 0rem 0.36rem 0.29rem;
}

.home_daio_top {
  z-index: 67;
}

.home_daio_right > img {
  width: 100%;
  height: 100%;
}

.home_daio_left > div:nth-child(1) > i {
  width: 0.47rem;
  height: 0.47rem;
  margin-left: 0.1rem;
  margin-top: 0.12rem;
  display: block;
  background: url(../assets/images/code_01.png) center center no-repeat;
  background-size: 0.47rem 0.47rem;
}

.home_daio_left > div:nth-child(2) {
  margin-top: 0.21rem;
  display: flex;
}

.home_daioxxx {
  position: relative;
  z-index: -1;
}

.home_daio_left > div:nth-child(2) > div {
  padding: 0.06rem 0.14rem;
  background: #9651ff;
  border-radius: 0.3rem;
  font-size: 0.22rem;
  color: #ffffff;
}

.home_daio_left > div:nth-child(2) > span {
  font-size: 0.22rem;
  font-weight: 400;
  line-height: 0.44rem;
  margin-left: 0.1rem;
  color: #1e1e2a;
}

.home_daio_measurement > h4 {
  font-size: 0.33rem;
  margin-top: 0.2rem;
  text-align: center;
  font-weight: bold;
  color: #1e1e2a;
}

.home_daio_bot > img {
  width: 1.81rem;
  height: 0.75rem;
  display: block;
  margin: 0 auto;
  margin-top: 0.1rem;
}

.home_daio_bot > p {
  width: 6.2rem;
  height: 0.9rem;
  font-size: 0.42rem;
  text-align: center;
  margin: 0 auto;
  margin-top: 0.33rem;
  font-weight: 800;
  color: #ffffff;
  text-shadow: 0.02rem 0.04rem 0.13rem rgba(37, 4, 4, 0.5);
}

.home_daio_bot {
  width: 7.05rem;
  height: 2.72rem;
  margin: 0 auto;
  overflow: hidden;
  background: url(../assets/images/ba_bg_04.png) center center no-repeat;
  background-size: 7.05rem 2.72rem;
}

.home_daio_bot > i {
  width: 0.44rem;
  height: 0.44rem;
  display: block;
  position: absolute;
  top: 0.41rem;
  right: 0.51rem;
  border-radius: 50%;
  background: #ffffff url(../assets/images/close.png) center center no-repeat;
  background-size: 0.23rem 0.23rem;
}

.home_daio_bot {
  width: 7.05rem;
  height: 2.72rem;
  margin: 0 auto;
  overflow: hidden;
  background: url(../assets/images/ba_bg_04.png) center center no-repeat;
  background-size: 7.05rem 2.72rem;
}

.home_daio_bot > i {
  width: 0.44rem;
  height: 0.44rem;
  display: block;
  position: absolute;
  top: 0.41rem;
  right: 0.51rem;
  border-radius: 50%;
  background: #ffffff url(../assets/images/close.png) center center no-repeat;
  background-size: 0.23rem 0.23rem;
}

.home_nav {
  display: flex;
  /* margin-top: .31rem; */
  justify-content: space-between;
}
.home_nav > img {
  /* width: .35rem; */
  height: 0.51rem;
  margin-left: 0.35rem;
}
.home_nav_img {
  width: 1.85rem;
  height: 0.72rem;
  background-color: #fff;
  border-radius: 0 0.4rem 0.4rem 0;
}
.home_nav_img > img {
  width: 1.4rem;
  display: block;
  margin: 0 auto;
  margin-top: 0.12rem;
}
.home_nav > .attestation {
  width: 1.85rem;
  line-height: 0.72rem;
  height: 0.72rem;
  justify-content: space-evenly;
  font-size: 0.21rem;
  color: #231815;
  display: flex;
  background-color: #fff;
  border-radius: 0.4rem 0 0 0.4rem;
}
.home_nav > .attestation > .gerenfalse {
  width: 0.52rem;
  height: 0.48rem;
  background: url(../assets/images/ba_bg_02.png) center center no-repeat;
  background-size: 0.52rem 0.48rem;
  margin: 0 auto;
  margin-top: 0.05rem;
}
.home_nav > span {
  position: absolute;
  top: 0.44rem;
  left: 0.86rem;
  font-size: 0.4rem;
  color: #0a83ff;
}
.home_nav_igm {
  width: 6.69rem;
  height: 1.63rem;
  margin: 0 auto;
  margin-top: 0.1rem;
  margin-bottom: 0.24rem;
  /* background: url(../assets/images/logo_02.png) center center no-repeat; */
  background-size: 6.69rem 1.63rem;
}

.home_top {
  /* height: 1.01rem; */
  /* transform: rotate(-13deg); */
  margin: 0 auto;
  background: url() center center no-repeat;
  background-size: 6.25rem 1.01rem;
  text-align: center;
  overflow: hidden;
  margin-top: 1.4rem;
}
.home_top > p {
  display: block;
  font-size: 0.42rem;
  border-radius: 100%;
  font-weight: 800;

  margin-top: 0.08rem;
  color: #ffffff;
  text-shadow: 0px 0px 0px rgba(37, 4, 4, 0.77), 2px 4px 13px rgba(37, 4, 4, 0.5);
}
.home_top > .home_top_icon {
  width: 7.03rem;
  height: 1.76rem;
  display: block;
  margin: 0 auto;
  background: url(../assets/images/ba_bg_03.png) center center no-repeat;
  background-size: 7.03rem 1.76rem;
  margin-top: 0.3rem;
}

.home_picker {
  width: 5.58rem;
  /* padding:  0.4rem; */
  padding-right: 0;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 0.21rem;
  margin-top: 0.35rem;
  /* position: absolute; */
  top: 4.4rem;
}

.home_picker_li {
  width: 48.65%;
  padding-left: 0.4rem;
  height: 0.76rem;
  position: relative;
  background-color: #fff;
  box-sizing: border-box;
  /* padding: 0 0.3rem; */
  line-height: 0.76rem;
  overflow: hidden;
  display: flex;
  margin-bottom: 0.15rem;
  border-radius: 25px;
}
.home_picker_li:nth-child(odd) {
  margin-right: 0.18rem;
}
.home_picker_li > span {
  width: 25%;
  font-size: 0.3rem;
  display: flex;
  justify-content: space-between;
  color: #530f99;
  /* float: left; */
}
.home_picker_li > input {
  color: #3c2a0a;
  width: 73%;
  padding-left: 0.15rem;
  margin-left: 0.15rem;
  font-size: 0.26rem;
  border-bottom: 0.01rem solid #e6e6e6;
}

.inside {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  z-index: 66;
  background: #22030e;
  opacity: 0.4;
}
.home_picker_li > input::-webkit-input-placeholder {
  font-size: 0.26rem;
}
.home_picker_li > i {
  position: absolute;
  right: 0.3rem;
  font-size: 0.14rem;
  color: #cdcdcd;
}
.home_picker_li_big {
  width: 100%;
}
.home_btn {
  text-align: center;
}
.inquire {
  background-color: #fa3143;
  font-size: 0.42rem;
  color: #ffffff;
  border-radius: 25px;
  line-height: 0.86rem;
  margin-top: 0.3rem;
  border: 0;
  padding: 0rem 0.8rem;
  box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.2);
}
.bottom {
  text-align: center;
  width: 100%;
  color: #fff;
  font-size: 0.28rem;
  margin-top: 0.4rem;
  margin-bottom: 1rem;
  /* position: fixed;
    bottom: .4rem;
    left: 50%;
    transform: translate(-50%,-50%); */
}
.bottom span {
  display: block;
}

.van-picker {
  position: fixed !important;
  bottom: 0;
  left: 0;
  z-index: 20;
  width: 100%;
}

.login {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 88;
  background-color: rgba(0, 0, 0, 0.8);
}
.auth_code > .count {
  background: #b8b8b8;
}
.login_content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6.11rem;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 0.48rem 0.48rem 0.24rem;
}
.login_content_top {
  position: relative;
  display: flex;
  overflow: hidden;
}
.login_content_top > div {
  width: 0.44rem !important;
  height: 0.44rem;
  position: absolute;
  top: 0rem;
  right: 0;
  background: #e6e6e6;
  border-radius: 50%;
}
.login_content_top > div > img {
  width: 0.23rem !important;
  align-self: center;
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}
.login_content_top span {
  font-size: 0.3rem;
  color: #818181;
  margin-left: 0.1rem;
  align-self: center;
  margin-top: 0.4rem;
}
.close {
  width: 0.3rem !important;
  align-self: center;
}
.mobile {
  border: 1px solid #b8b8b8;
  width: 100%;
  height: 0.82rem;
  padding: 0.1rem;
  border-radius: 0.5rem;
  padding-left: 0.9rem;
  margin-top: 0.3rem;
  font-size: 0.3rem;
}
.auth_code .mobiletop {
  border: 1px solid #b8b8b8;
  width: 2.8rem;
  height: 0.64rem;
  padding: 0.1rem;
  border-radius: 0.3rem;
  padding-left: 0.37rem;

  font-size: 0.3rem;
}
.auth_code {
  /* margin-top: 0.3rem; */
  margin-top: 0.3rem;
  /* border-bottom: 1px solid #d9d9d9; */
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  position: relative;
}
.auth {
  font-size: 0.5rem !important;
  font-weight: bold;
  color: #1e1e2a !important;
  display: block;
  width: 100%;
  margin-top: 0.2rem;
  text-align: center;
}

.login_p {
  width: 4.53rem;
  margin: 0 auto;
  font-size: 0.19rem;
  font-weight: 400;
  color: #1e1e2a;
  text-align: center;
  margin-top: 0.15rem;
}
.login_tab {
  width: 100%;
  display: block;
  font-size: 0.22rem;
  text-align: center;
  margin-top: 0.24rem;
  font-weight: 400;
  color: #4a4a4a;
}
.login_p > span {
  color: #7979b8;
}
.auth_code input {
  width: 60%;
  padding: 0.1rem;
  font-size: 0.3rem;
}
.auth_code span {
  display: inline-block;
  text-align: right;
  width: 2rem !important;
  height: 0.64rem;
  text-align: center;
  background: linear-gradient(0deg, #833ee9 0%, #651fe9 100%);
  border-radius: 0.32rem;
  font-size: 0.29rem;
  font-weight: 500;
  color: #fefefe;
  line-height: 0.64rem;
  color: #fff;
}
.auth_code span {
  width: 40%;
}

.home_daio_images {
  width: 6.2rem;
  margin-top: 0.2rem;
  text-align: center;
  color: #000;
  margin: 0 auto;
  /* margin-top: .2rem; */
  font-size: 0.21rem;
  height: 1rem;
  background: url(../assets/images/ba_bg_05.png) center center no-repeat;
  background-size: 6.2rem 1.2rem;
  margin-top: 0.2rem;
  line-height: 1.1rem;
}
.itop {
  width: 0.44rem;
  height: 0.44rem;
  display: block;
  position: absolute;
  top: 0.41rem;
  right: 0.51rem;
  border-radius: 50%;
  background: #ffffff url(../assets/images/close.png) center center no-repeat;
  background-size: 0.23rem 0.23rem;
}
.login_btn {
  width: 2.92rem;
  display: block;
  background: linear-gradient(0deg, #833ee9 0%, #651fe9 100%);
  margin: 0 auto;
  border-radius: 32px;
  color: #fff;
  font-size: 0.3rem;
  border: 0;
  padding: 0.16rem 0;
  border-radius: 25px;
  margin-top: 0.23rem;
}

.auth_home {
  width: 0.82rem;
  height: 0.82rem;
  position: absolute;
  left: 0.1rem;
  top: 0.3rem;
  background: url(../assets/images/icon_01.png) center center no-repeat;
  background-size: 0.72rem 0.72rem;
}

.auth_two {
  width: 0.82rem;
  height: 0.82rem;
  position: absolute;
  left: 0.1rem;
  top: 0.3rem;
  background: url(../assets/images/icon_02.png) center center no-repeat;
  background-size: 0.62rem 0.72rem;
}

.auth_yes {
  width: 0.82rem;
  height: 0.72rem;
  position: absolute;
  left: 0.1rem;
  top: 0rem;
  background: url(../assets/images/icon_03.png) center center no-repeat;
  background-size: 0.62rem 0.72rem;
}
.auth_gjgj {
  width: 0.82rem;
  height: 0.72rem;
  position: absolute;
  left: 0.1rem;
  top: 0.3rem;
  background: url(../assets/images/icon_04.png) center center no-repeat;
  background-size: 0.32rem 0.38rem;
}
</style>
